import { render } from "./SavedItemsPage.vue?vue&type=template&id=28596bac"
import script from "./SavedItemsPage.vue?vue&type=script&lang=js"
export * from "./SavedItemsPage.vue?vue&type=script&lang=js"

import "./SavedItemsPage.vue?vue&type=style&index=0&id=28596bac&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__